import { Toaster } from "@bleu.builders/ui";
import { usePostHog } from "posthog-js/react";
import React from "react";
import { useLoaderData, useLocation } from "react-router";

import { hexToCssHslValue } from "#/lib/hexToCssHslValue";
import { WizardForm } from "#/pages/(components)/wizard/Form";

import { ExternalDiagnosisFormHeader } from "./(components)/ExternalDiagnosisHeader";
import { ExternalDiagnosisFormHelmet } from "./(components)/ExternalDiagnosisHelmet";
import { ExternalDiagnosisExpired } from "./external_diagnosis_expired";

interface DiagnosisLoader {
  data: {
    brand_theme: {
      logo: string;
      favicon: string;
      primary_color: string;
    };
  };
  expired?: boolean;
}

export const ExternalDiagnosisForm = ({ mode = "update" }) => {
  const { data, expired } = useLoaderData() as DiagnosisLoader;

  if (expired) {
    return <ExternalDiagnosisExpired />;
  }

  const location = useLocation();
  const posthog = usePostHog();

  React.useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  const primaryColor = data?.brand_theme?.primary_color || "#000000";

  const style = {
    "--primary": hexToCssHslValue(primaryColor),
  } as React.CSSProperties;

  return (
    <>
      <Toaster position="top-right" />
      <div
        className="max-w-7xl mx-auto w-full pt-4 pb-2 md:px-24 xl:px-32"
        style={style}
      >
        <ExternalDiagnosisFormHelmet
          favicon={data?.brand_theme?.favicon || data?.brand_theme?.logo}
        />
        <ExternalDiagnosisFormHeader icon={data?.brand_theme?.logo} />
        <WizardForm mode={mode} />
      </div>
    </>
  );
};
